import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "send-email--sprite",
  "use": "send-email--sprite-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol viewBox=\"0 0 14 14\" xmlns=\"http://www.w3.org/2000/svg\" id=\"send-email--sprite\">\n<path d=\"M12 0.666504H1.33333C0.6 0.666504 0 1.2665 0 1.99984V9.99984C0 10.7332 0.6 11.3332 1.33333 11.3332H7.33333V9.99984H1.33333V3.33317L6.66667 6.6665L12 3.33317V6.6665H13.3333V1.99984C13.3333 1.2665 12.7333 0.666504 12 0.666504ZM6.66667 5.33317L1.33333 1.99984H12L6.66667 5.33317ZM11.3333 7.99984L14 10.6665L11.3333 13.3332V11.3332H8.66667V9.99984H11.3333V7.99984Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol